
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(19692|3588)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
